import types from '../actions/usersActionsTypes';

const INITIAL_STATE = {
    isUsersLoading: false,
    selectedUser: {},
    selectedPartner: {},
    selectedGeneralPartner: {},
    searchUser: "",
    searchPartner: "",
    filterPartner: {},
    filterApplication: {},
    modeUserModal: null,
    modePartnerModal: null,
    modeGeneralModal: null,
    showUserModal: false,
    showPartnerModal: false,
    showGeneralModal: false,
    showUsers: true,
    showEditUser: false,
    showUnlinkModal: false,
    modeMainEmailModal: null,
    showMainEmailUserModal: false,
    mainEmailSelectedUser: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.USERS_SET_USERS_LOADING:
            return { ...state, isUsersLoading: action.payload };

        case types.USERS_SET_SELECTED_USER:
            return { ...state, selectedUser: action.payload };

        case types.USERS_SET_SELECTED_PARTNER:
            return { ...state, selectedPartner: action.payload };

        case types.USERS_SET_SELECTED_GENERAL_PARTNER:
            return { ...state, selectedGeneralPartner: action.payload };

        case types.USERS_SET_SEARCH_USER:
            return { ...state, searchUser: action.payload };

        case types.USERS_SET_SEARCH_PARTNER:
            return { ...state, searchPartner: action.payload };

        case types.USERS_SET_FILTER_PARTNER:
            return { ...state, filterPartner: action.payload };

        case types.USERS_SET_FILTER_APPLICATION:
            return { ...state, filterApplication: action.payload };

        case types.USERS_SET_MODE_USER_MODAL:
            return { ...state, modeUserModal: action.payload };

        case types.USERS_SET_MODE_PARTNER_MODAL: 
            return { ...state, modePartnerModal: action.payload };

        case types.USERS_SET_MODE_GENERAL_MODAL:
            return { ...state, modeGeneralModal: action.payload };

        case types.USERS_SET_SHOW_USER_MODAL:
            return { ...state, showUserModal: action.payload };

        case types.USERS_SET_SHOW_PARTNER_MODAL:
            return { ...state, showPartnerModal: action.payload };

        case types.USERS_SET_SHOW_GENERAL_MODAL:
            return { ...state, showGeneralModal: action.payload };

        case types.USERS_SET_SHOW_USERS:
            return { ...state, showUsers: action.payload };

        case types.USERS_SET_SHOW_EDIT_USER:
            return { ...state, showEditUser: action.payload };

        case types.USERS_SET_SHOW_UNLINK_MODAL:
            return { ...state, showUnlinkModal: action.payload };

        case types.USERS_SET_MAIN_EMAIL_MODAL: 
            return { ...state, modeMainEmailModal: action.payload };

        case types.USERS_SET_MAIN_EMAIL_SHOW_MODAL:
            return { ...state, showMainEmailUserModal: action.payload };
            
        case types.USERS_SET_MAIN_EMAIL_SELECTED_USER:
            return { ...state, mainEmailSelectedUser: action.payload };

        case types.USERS_RESET_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};
